module.exports = __webpack_public_path__ + "img/774.560b2bfb.jpg";